import React, { Component } from "react";
import Input from "../2/Controls/Input";
import Spinner from "../Common/Spinner";
import Pagination from "react-js-pagination";
import axios from "axios";
import "../2/ListPage.css";
import ImageButton from "../2/Controls/ImageButton";

class WHInboundList extends Component {
  constructor() {
    super();
    this.state = {
      fromDate: null,
      toDate: null,
      store: "",
      smartStoreList: [],
      transactionStatus: "Pending",
      searchStatus: "Pending",
      selectedStoreID: "",
      records: [],
      showViewDetails: true,
      selectedRecord: null,
      from: 0,
      size: 50,
      loading: false,
      activePage: 1,
      paginationStatus: "No records to display",
      buttons: [],
      approvedAmountError: "",
      SONo: "",
      SINo: "",
      verificationStatus: "",
      pendingCount: 0,
      putAwayCount: 0,
      completedCount: 0,
      reInwardCount: 0,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
    this.fetchStatusCounts = this.fetchStatusCounts.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.renderStatusFilters = this.renderStatusFilters.bind(this);
    this.formatToIST_manual = this.formatToIST_manual.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onClearSearch = this.onClearSearch.bind(this);
  }

  async componentDidMount() {
    this.loadData(
      this.state.activePage,
      this.state.size,
      this.props.user.store.key,
      this.state.fromDate,
      this.state.toDate,
      this.state.transactionStatus,
      this.state.SONo,
      this.state.SINo,
      this.state.verificationStatus,
      false
    );
  }

  async fetchStatusCounts() {
    const BaseURL = "https://backend-197598313260.asia-south1.run.app";
    //const BaseURL = "http://localhost:4000"
    const params = {
      registrationID: this.props.user.user.RegistrationID,
      storeID: this.props.user.store.key,
    };

    try {
      let response = await axios.get(
        `${BaseURL}/v1/vendorstockinward/statuscounts`,
        {
          params: params,
        }
      );
      if (response.data.code === "0") {
        console.log("response", response);
        this.setState({
          pendingCount: response.data.data.Pending
            ? response.data.data.Pending
            : 0,
          putAwayCount: response.data.data["Put away - Pending"]
            ? response.data.data["Put away - Pending"]
            : 0,
          completedCount: response.data.data.Completed
            ? response.data.data.Completed
            : 0,
          reInwardCount: response.data.data["Re Inward"]
            ? response.data.data["Re Inward"]
            : 0,
        });
      }
    } catch (error) {}
  }

  onSearchClick() {
    this.loadData(
      this.state.activePage,
      this.state.size,
      this.props.user.store.key,
      this.state.fromDate,
      this.state.toDate,
      this.state.transactionStatus,
      this.state.SONo,
      this.state.SINo,
      this.state.verificationStatus,
      false
    );
  }

  onClearSearch() {
    this.setState({
      fromDate: null,
      toDate: null,
      SINo: "",
    });
    this.loadData(
      this.state.activePage,
      this.state.size,
      this.props.user.store.key,
      null,
      null,
      this.state.transactionStatus,
      this.state.SONo,
      "",
      this.state.verificationStatus,
      false
    );
  }

  async loadData(
    page,
    size,
    storeID,
    fromDate,
    toDate,
    status,
    SONo = "",
    SINo = "",
    verificationStatus = "",
    exportData = false
  ) {
    this.setState({ loading: true });
    this.fetchStatusCounts();
    var headers = {};
    var params = {
      page: page,
      limit: size,
      registrationID: this.props.user.user.RegistrationID,
      storeID: this.props.user.store.key,
      search: "",
      filters: {},
    };

    if (storeID) params.storeID = storeID;
    if (status) {
      params.filters.status = status;
      if (status === "Completed") params.sort = "desc";
    }
    if (fromDate && toDate) {
      params.filters.fromDate = fromDate;
      params.filters.toDate = toDate;
    }
    if (SINo && SINo.trim() !== "") params.search = SINo.trim();
    // if (SONo && SONo.trim() !== "") params.filters.SONo = SONo.trim();
    // if (verificationStatus && verificationStatus.trim() !== "")
    //   params.filters.verificationstatus = verificationStatus.trim();

    // console.log("params", JSON.stringify(params));

    const BaseURL = "https://backend-197598313260.asia-south1.run.app";
    const response = await axios.get(`${BaseURL}/v1/vendorstockinward`, {
      params,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });

    // console.log("response", response);
    let pageRecords = response.data.data;
    let totalItemsCount = response.data.pagination.total;
    this.setState({
      records: pageRecords,
      totalItemsCount: totalItemsCount,
      loading: false,
    });
    this.showPaginationStatus(totalItemsCount, (page - 1) * size);
  }

  formatToIST_manual(isoString) {
    if (!isoString) {
      return "";
    }
    if (isoString && isoString === "") {
      return "";
    }
    const ms = new Date(isoString).getTime();
    const istOffsetMs = (5 * 60 + 30) * 60 * 1000; // 5h30 in ms
    const ist = new Date(ms + istOffsetMs);

    const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][
      ist.getUTCDay()
    ]; // use UTC getters because we built IST time as UTC-based date
    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ][ist.getUTCMonth()];
    const day = String(ist.getUTCDate()).padStart(2, "0");
    const year = ist.getUTCFullYear();
    const hh = String(ist.getUTCHours()).padStart(2, "0");
    const mm = String(ist.getUTCMinutes()).padStart(2, "0");
    const ss = String(ist.getUTCSeconds()).padStart(2, "0");

    return `${weekday} ${month} ${day} ${year} ${hh}:${mm}:${ss}`;
  }

  showPaginationStatus(totalItemsCount, recordFrom) {
    let paginationStatus;
    if (totalItemsCount === 0) {
      paginationStatus = "No records to display";
    } else if (recordFrom + 1 === totalItemsCount) {
      paginationStatus =
        "Showing " + totalItemsCount + " of " + totalItemsCount;
    } else if (recordFrom + this.state.size + 1 > totalItemsCount) {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        totalItemsCount +
        " of " +
        totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        (recordFrom + this.state.size) +
        " of " +
        totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  removeTimeFromISO(dateStr) {
    if (!dateStr) return dateStr;

    // Convert to string safely
    const str = String(dateStr);

    // Check if it’s an ISO format with time
    if (str.includes("T")) {
      return str.split("T")[0]; // Keep only YYYY-MM-DD
    }

    return str; // already clean
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
    this.loadData(
      pageNumber,
      this.state.size,
      this.state.selectedStoreID,
      this.state.fromDate,
      this.state.toDate,
      this.state.transactionStatus,
      this.state.SONo,
      this.state.SINo,
      this.state.verificationStatus,
      false
    );
  }

  onStatusChange(status) {
    this.setState({ transactionStatus: status, searchStatus: status });
    this.loadData(
      this.state.activePage,
      this.state.size,
      this.state.selectedStoreID,
      this.state.fromDate,
      this.state.toDate,
      status,
      this.state.SONo,
      this.state.SINo,
      this.state.verificationStatus,
      false
    );
  }

  renderStatusFilters() {
    return (
      <>
        <button
          type="button"
          style={{
            borderTopLeftRadius: "32px",
            borderBottomLeftRadius: "32px",
          }}
          className={
            this.state.searchStatus === "Pending"
              ? "btn button-flat button-border button-lg button-selected  button-left-rounded"
              : "btn button-flat button-border button-lg button-left-rounded"
          }
          onClick={() => this.onStatusChange("Pending")}
        >
          Pending - {this.state.pendingCount}
        </button>
        <button
          type="button"
          className={
            this.state.searchStatus === "Put away - Pending"
              ? "btn button-flat button-border button-lg button-selected "
              : "btn button-flat button-border button-lg"
          }
          onClick={() => this.onStatusChange("Put away - Pending")}
        >
          Put away - Pending - {this.state.putAwayCount}
        </button>
        <button
          type="button"
          className={
            this.state.searchStatus === "Re Inward"
              ? "btn button-flat button-border button-lg button-selected "
              : "btn button-flat button-border button-lg"
          }
          onClick={() => this.onStatusChange("Re Inward")}
        >
          Re-Innward - {this.state.reInwardCount}
        </button>
        <button
          type="button"
          className={
            this.state.searchStatus === "Completed"
              ? "btn button-flat button-border button-lg button-selected "
              : "btn button-flat button-border button-lg "
          }
          onClick={() => this.onStatusChange("Completed")}
        >
          Completed - {this.state.completedCount}
        </button>
        <button
          type="button"
          style={{
            borderTopRightRadius: "32px",
            borderBottomRightRadius: "32px",
          }}
          className={
            this.state.searchStatus === ""
              ? "btn button-flat button-border button-lg button-selected "
              : "btn button-flat button-border button-lg"
          }
          onClick={() => this.onStatusChange("")}
        >
          All
        </button>
      </>
    );
  }

  render() {
    return (
      <div className="header-margin">
        <div className="list-page">
          <div className="list-page-header">
            <div className="left left-40">
              <div className="list-page-header-title">WH Inbound</div>
            </div>
            <div className="right right-60">
              {/* <div
                className="btn-group pull-right hidden-xs"
                style={{ paddingRight: "10px" }}
              > */}
              {this.renderStatusFilters()}
              {/* </div> */}
            </div>
          </div>
          <div className="list-page-content">
            <div className="row">
              <div className="col-md-2">
                <Input
                  type="text"
                  label="Invoice No"
                  value={this.state.SINo}
                  onChange={(value) => this.setState({ SINo: value })}
                />
              </div>
              {/* {this.state.searchStatus === "Completed" && (
                <>
                  <div className="col-md-2">
                    <Input
                      type="date"
                      label="From Date"
                      value={this.state.fromDate}
                      onChange={(value) => this.setState({ fromDate: value })}
                    />
                  </div>
                  <div className="col-md-2">
                    <Input
                      type="date"
                      label="To Date"
                      value={this.state.toDate}
                      onChange={(value) => this.setState({ toDate: value })}
                    />
                  </div>
                </>
              )} */}
              <div className="col-md-2" style={{ marginTop: "20px" }}>
                <button
                  type="button"
                  className="btn btn-primary btn-flat btn-md pull-right"
                  style={{ marginLeft: "5px" }}
                  onClick={this.onSearchClick}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-default btn-flat btn-md pull-right"
                  onClick={this.onClearSearch}
                >
                  Clear
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.loading && <Spinner />}
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>SO No</th>
                      <th>Invoice No</th>
                      <th>Invoice Date</th>
                      <th>Invoice Qty</th>
                      <th>Invoice Amount</th>
                      <th>Inward Qty</th>
                      <th>Damage Qty</th>
                      <th>Short Qty</th>
                      <th>Receiving Time</th>
                      <th>Completion Time</th>
                      <th>Status</th>
                      <th sttyle={{ width: "100px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.records.map((record) => (
                      <tr>
                        <td>{record.SONo}</td>
                        <td>{record.SINo}</td>
                        <td>{this.formatToIST_manual(record.CreatedDate)}</td>
                        <td style={{ textAlign: "right" }}>{record.SIQty}</td>
                        <td style={{ textAlign: "right" }}>
                          {record.SIAmount}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.TotalInwardQty}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.TotalDamageQty}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.TotalShortQty}
                        </td>
                        <td>{this.formatToIST_manual(record.ReceivingTime)}</td>
                        <td>{this.formatToIST_manual(record.CompletedTime)}</td>
                        <td>{record.Status}</td>
                        <td>
                          {/* <a
                            onClick={() => {
                              let redirectionLink = "";
                              if (record.Status === "Pending") {
                                redirectionLink =
                                  "/home/inventory/Packaging/" + record.key; // 68f8fa9cdb4b3ec1a9ddd7e1
                              } else {
                                redirectionLink =
                                  "/home/inventory/whinbound/" + record.key;
                              }
                              this.props.history.push({
                                pathname: redirectionLink,
                                state: {
                                  verification: true,
                                  RegistrationID: record.RegistrationID,
                                  StoreID: record.StoreID,
                                },
                              });
                            }}
                          >
                            View
                          </a> */}
                          <ImageButton
                            type="view"
                            label=""
                            onClick={() => {
                              let redirectionLink = "";
                              if (record.Status === "Pending") {
                                redirectionLink =
                                  "/home/inventory/Packaging/" + record._id; // 68f8fa9cdb4b3ec1a9ddd7e1
                              } else {
                                redirectionLink =
                                  "/home/inventory/whinbound/" + record._id;
                              }
                              this.props.history.push({
                                pathname: redirectionLink,
                              });
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {this.state.totalItemsCount > 0 && (
            <div className="row">
              <div className="col-md-12">
                <div className="pull-left" style={{ marginTop: "25px" }}>
                  {this.state.paginationStatus}
                </div>
                <div className="pull-right">
                  <Pagination
                    activePage={this.state.activePage} //this.state.activePage
                    itemsCountPerPage={this.state.size}
                    totalItemsCount={this.state.totalItemsCount}
                    pageRangeDisplayed={2}
                    onChange={this.handlePageChange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      //   <div className="content-wrapper">
      //     <section className="content">
      //       <ReportHeader
      //         title={"WH Inbound"}
      //         showBack={true}
      //         onBack={() => {
      //           //   console.log("back clicked");
      //           this.props.history.push({ pathname: "/home/" });
      //         }}
      //       ></ReportHeader>
      //       <ReportBody>
      //         <div className="row">
      //           <div className="col-md-12">{this.renderStatusFilters()}</div>
      //         </div>

      //         <div className="row">
      //           <div className="col-md-8"></div>
      //           <div className="col-md-4">
      //             <ReportButton
      //               type="search"
      //               onClick={() => {
      //                 this.loadData(
      //                   1,
      //                   this.state.size,
      //                   this.state.selectedStoreID,
      //                   this.state.fromDate,
      //                   this.state.toDate,
      //                   this.state.transactionStatus,
      //                   this.state.SONo,
      //                   this.state.SINo,
      //                   this.state.verificationStatus,
      //                   false
      //                 );
      //               }}
      //             />
      //             <ReportButton
      //               type="clear"
      //               onClick={() => {
      //                 this.setState({
      //                   page: 1,
      //                   size: this.state.size,
      //                   selectedStoreID: "",
      //                   fromDate: "",
      //                   toDate: "",
      //                   transactionStatus: "Pending",
      //                   SONo: "",
      //                   SINo: "",
      //                   verificationStatus: "",
      //                 });
      //                 this.loadData(
      //                   1,
      //                   50,
      //                   "",
      //                   null,
      //                   null,
      //                   "Pending",
      //                   "",
      //                   "",
      //                   "",
      //                   false
      //                 );
      //               }}
      //             />
      //             <ReportButton
      //               type="export"
      //               onClick={() =>
      //                 this.loadData(
      //                   this.state.activePagefrecordFrom,
      //                   this.state.size,
      //                   this.state.selectedStoreID,
      //                   this.state.fromDate,
      //                   this.state.toDate,
      //                   this.state.transactionStatus,
      //                   this.state.SONo,
      //                   this.state.SINo,
      //                   this.state.verificationStatus,
      //                   true
      //                 )
      //               }
      //             />
      //           </div>
      //         </div>
      //         <br />
      //         {/* <br /> */}

      //       </ReportBody>
      //     </section>
      //   </div>
    );
  }
}

export default WHInboundList;
